module.exports = __webpack_public_path__ + "static/media/plus.46e0a872.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/ShareHistory/plus.svg
// module id = 368
// module chunks = 0